import React from 'react';
import T from 'prop-types';
// components
import { FormattedMessage } from 'react-intl';
import Button from 'components/Button';
import TimeAgo from 'components/TimeAgo/TimeAgo';
// utils
import classnames from 'classnames/bind';
// styles
import styles from './ReportTemplateRow.module.scss';

const cn = classnames.bind(styles);

const ReportTemplateRow = ({ template, onSelect }) => (
  <div className={cn('report-template-row')}>
    <div className={cn('name-section')}>
      {template.name}
    </div>
    <div className={cn('vertical-divider')} />
    <div className={cn('reports-count-section')}>
      <FormattedMessage id="general.submittedReportsCount" values={{ reports_count: template.svrs_count || 0 }} />
    </div>
    <div className={cn('vertical-divider')} />
    <div className={cn('report-time-section')}>
      {template.last_svr_created_at ? (
        <FormattedMessage
          id="general.lastReportSubmitted"
          values={{ time_ago: <TimeAgo date={template.last_svr_created_at} /> }}
        />
      ) :
        <FormattedMessage id="general.noReportsSubmitted" />
      }
    </div>
    <div className={cn('action-section')}>
      <Button onClick={onSelect} className={cn('select-btn')} primary>
        <FormattedMessage id="general.button.select" />
      </Button>
    </div>
  </div>
);

ReportTemplateRow.propTypes = {
  template: T.object.isRequired,
  onSelect: T.func.isRequired,
};

export default ReportTemplateRow;
